import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function PageHero({ eyebrow, title, subtitle, image, ctaLabel = "Request a Quote", ctaTo = "/contact" }) {
  return (
    <section data-testid="page-hero" className="relative isolate overflow-hidden bg-[#16302B] text-white">
      {image && (
        <div className="absolute inset-0">
          <img
            src={image}
            alt=""
            className="h-full w-full object-cover opacity-60"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#16302B]/95 via-[#16302B]/70 to-[#16302B]/20" />
        </div>
      )}

      <div className="relative mx-auto max-w-7xl px-6 pt-24 pb-20 md:px-12 md:pt-32 md:pb-28">
        {eyebrow && (
          <p data-testid="page-hero-eyebrow" className="eyebrow reveal text-[#D95D39]">
            {eyebrow}
          </p>
        )}
        <h1
          data-testid="page-hero-title"
          className="reveal reveal-delay-1 mt-4 max-w-4xl font-display text-4xl font-black leading-[0.95] tracking-tighter sm:text-5xl lg:text-6xl"
        >
          {title}
        </h1>
        {subtitle && (
          <p
            data-testid="page-hero-subtitle"
            className="reveal reveal-delay-2 mt-6 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg"
          >
            {subtitle}
          </p>
        )}
        <div className="reveal reveal-delay-3 mt-10 flex flex-wrap gap-4">
          <Link
            to={ctaTo}
            data-testid="page-hero-cta"
            className="inline-flex items-center gap-2 bg-[#D95D39] px-7 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-[#B94B2C]"
          >
            {ctaLabel} <ArrowRight size={16} strokeWidth={2.5} />
          </Link>
        </div>
      </div>
    </section>
  );
}
